import Vue from 'vue';
import App from './App';

/**
 * Mount the Vue instance on the DOM element "#wp-vue-app" in the Custom Page Template
 */
new Vue({
	el: '#wp-vue-app',
	data:{
		placeholder:'Hotel'
	},
	render: h => h( App )
});




// WEBPACK FOOTER //
// ./src/main.js